import { Component, OnInit, ViewChild } from '@angular/core';
import { onSideNavChange, animateText } from '../../../animations/animations'
import { SidenavService } from '../../../services/sidenav.service'
import { Router } from '@angular/router';
import { VersaoProd, VersaoDebug, TipoCompilacao } from '../../../versao';
import { MatAccordion } from '@angular/material/expansion';
import { environment } from '../../../../environments/environment';
import { AngularFireAuth } from '@angular/fire/auth';
import { UsuarioService } from '../../../services/usuario.service';

interface Page {
  link: string;
  name: string;
  icon: string;
}

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
  animations: [onSideNavChange, animateText],
  // viewProviders: [MatExpansionPanel]

})
export class LeftMenuComponent implements OnInit {

  @ViewChild('accordion', { static: true }) accordion: MatAccordion

  public sideNavState: boolean = false;
  public linkText: boolean = true;

  sVersao = TipoCompilacao ? VersaoProd : VersaoDebug;
  step; //controle de expansão do menu

  menuData: any[] = [
    {
      displayName: 'Home',
      iconName: 'home',
      route: '/pages/dashboard',
      hidden: false,
    },
    {
      displayName: 'Pedidos',
      iconName: 'bookmark',
      route: '/pages/consultar-pedidos',
      hidden: false,
    },
    {
      displayName: 'Financeiro',
      index: 'Financeiro',
      iconName: 'local_atm',
      hidden: false,
      children: [
        {
          displayName: 'Adicionar crédito',
          iconName: '',
          route: '/pages/adicionar-credito',
          hidden: false,
        },
        {
          displayName: 'Relatório boleto',
          iconName: '',
          route: '/pages/relatorio-boletos',
          hidden: false,
        },
      ]
    },
    {
      displayName: 'Solicitações',
      iconName: 'add_alert',
      index: 'Solicitacoes',
      hidden: false,
      children: [
        {
          displayName: 'Cadastro',
          iconName: '',
          route: '/pages/solicitacoes-cadastro',
          hidden: false,
        },
        {
          displayName: 'Exclusão de dados',
          iconName: '',
          route: '/pages/solicitacoes-exclusao-dados',
          hidden: false,
        },
      ]
    },
    {
      displayName: 'Promoções',
      iconName: 'percent',
      route: '/pages/gerenciar-promocoes',
      hidden: false,
    },
    {
      displayName: 'Rotas',
      iconName: 'map',
      route: '/pages/mapa-rotas',
      hidden: false,
    },
    {
      displayName: 'Cadastros',
      iconName: 'add',
      index: 'cadastros',
      hidden: false,
      children: [
        {
          displayName: 'Fornecedor',
          iconName: '',
          route: '/pages/novo-fornecedor',
          hidden: false,
        },
        {
          displayName: 'Grupo',
          iconName: '',
          route: '/pages/novo-grupo',
          hidden: false,
        },
        {
          displayName: 'Produto',
          iconName: '',
          route: '/pages/novo-produto',
          hidden: false,
        },
        {
          displayName: 'Unidade de Medida',
          iconName: '',
          route: '/pages/novo-unidade-medida',
          hidden: false,
        },
        {
          displayName: 'Cidade',
          iconName: '',
          route: '/pages/nova-cidade',
          hidden: false,
        },
        {
          displayName: 'Usuários',
          iconName: '',
          route: '/pages/novo-usuario',
          hidden: false,
          children: [
            {
              displayName: 'Cliente',
              iconName: '',
              route: '/pages/novo-cliente',
              hidden: false,
            },
            {
              displayName: 'Funcionário',
              iconName: '',
              route: '/pages/novo-funcionario',
              hidden: false,
            },
          ]
        },
        {
          displayName: 'Promoções em lote (clientes)',
          iconName: 'attach_money',
          route: '/pages/vincular-promocao-lote-clientes',
          hidden: false,
        },
      ]
    },
    {
      displayName: 'Consultas',
      iconName: 'search',
      index: 'consultas',
      hidden: false,
      children: [
        {
          displayName: 'Fornecedor',
          iconName: '',
          route: '/pages/consultar-fornecedor',
          hidden: false,
        },
        {
          displayName: 'Grupos',
          iconName: '',
          route: '/pages/consultar-grupo',
          hidden: false,
        },
        {
          displayName: 'Produto',
          iconName: '',
          route: '/pages/consultar-produto',
          hidden: false,
        },
        {
          displayName: 'Unidade de Medida',
          iconName: '',
          route: '/pages/consultar-unidade-medida',
          hidden: false,
        },
        {
          displayName: 'Usuários',
          iconName: '',
          route: '/pages/consultar-usuário',
          hidden: false,
          children: [
            {
              displayName: 'Cliente',
              iconName: '',
              route: '/pages/consultar-cliente',
              hidden: false,
            },
            {
              displayName: 'Funcionário',
              iconName: '',
              route: '/pages/consultar-funcionario',
              hidden: false,
            },
          ]
        },
      ]
    },
    {
      displayName: 'Relatórios',
      iconName: 'bar_chart',
      index: 'relatorios',
      hidden: false,
      children: [
        {
          displayName: 'Vendas',
          iconName: '',
          route: '/pages/relatorio-vendas',
          hidden: false,
        },
        {
          displayName: 'Comissão',
          iconName: '',
          route: '/pages/relatorio-comissao',
          hidden: false,
        },
        {
          displayName: 'Mercadorias vendidas',
          iconName: '',
          route: '/pages/relatorio-mercadorias-vendidas',
          hidden: false,
        },
        {
          displayName: 'Estoque',
          iconName: '',
          route: '/pages/relatorio-estoque',
          hidden: false,
        },
        {
          displayName: 'Acessos',
          iconName: '',
          route: '/pages/relatorio-acessos',
          hidden: false,
        },
        {
          displayName: 'Promoções-clientes',
          iconName: '',
          route: '/pages/relatorio-promocoes-clientes',
          hidden: false,
        },
        {
          displayName: 'Movimentação estoque',
          iconName: '',
          route: '/pages/relatorio-movimentacao-estoque',
          hidden: false,
        },
        {
          displayName: 'Pagamentos',
          iconName: '',
          route: '/pages/relatorio-pagamentos',
          hidden: false,
        },
        /*{
          displayName: 'Boletos',
          iconName: '',
          route: '/pages/relatorio-boletos',
          hidden: false,
        },*/
      ]
    },
    {
      displayName: 'Sistema',
      iconName: 'settings',
      index: 'configuracoes',
      children: [
        {
          displayName: 'Fechar comissão',
          iconName: '',
          route: '/pages/fechar-comissao',
          hidden: false,
        },
        {
          displayName: 'Valores mínimos e pagamentos',
          iconName: '',
          route: '/pages/valores-minimos',
          hidden: false,
        },
        {
          displayName: 'Entrada / Saída estoque',
          iconName: '',
          route: '/pages/entrada-saida-estoque',
          hidden: false,
        },
        {
          displayName: 'Gerenciar estoque',
          iconName: '',
          route: '/pages/gerenciar-estoque',
          hidden: false,
        },
        {
          displayName: 'Manutenção loja',
          iconName: '',
          route: '/pages/manutencao-loja',
          hidden: false,
        },
      ]
    },
  ];


  constructor(
    private _sidenavService: SidenavService,
    private router: Router,
    private af: AngularFireAuth,
    private usuarioService: UsuarioService
  ) {
    this.af.authState.subscribe((snap: any) => {

      if (snap.uid !== environment.idCliente) {

        this.usuarioService.getFuncionario(snap.uid).subscribe(dados => {
          if (dados) {
            const dadosFuncionario: any = dados;
            const permissoes = dadosFuncionario.Permissoes;
            let bHiddenAll = true;
            let bHiddenAllSubMenu = true;


            //Gerenciamento de pedidos está desabilitado|
            this.menuData[1].hidden = true; //Pedidos
            this.menuData[2].children[0].hidden = true; //Financeiro
            this.menuData[3].hidden = true; //Solicitações de cadastro
            this.menuData[4].hidden = true; // Promoções
            this.menuData[5].hidden = true; // Mapa Rotas
            this.menuData[6].children[3].hidden = true; // Unidade de medida
            this.menuData[6].children[4].hidden = true; // Cidades
            this.menuData[6].children[6].hidden = true; // Promoções em lotes
            this.menuData[7].children[3].hidden = true; // Unidade de medida
            this.menuData[8].children[2].hidden = true; // Relatório mercadorias vendidas
            this.menuData[8].children[3].hidden = true; // Estoque
            this.menuData[8].children[4].hidden = true; // Acessos
            this.menuData[8].children[5].hidden = true; // Promoções-clientes
            this.menuData[9].hidden = true; // Configurações gerais > Valores mínimo e Fechamento de comissão


            // if (!permissoes.Vender) {
            //   this.menuData[1].hidden = true; //Pedidos
            // }

            // if (!permissoes.Gerente) {
            //   this.menuData[5].hidden = true;
            //   //Cadastros
            //   this.menuData[3].children[3].hidden = true; // Unidade de medida
            //   this.menuData[3].children[4].hidden = true; // Cidades
            //   //Consultas
            //   this.menuData[4].children[3].hidden = true; // Unidade de medida
            // }

            // Verificar cadastros
            if (!permissoes.Cadastrar.Fornecedores) {
              this.menuData[6].children[0].hidden = true;
            } else
              bHiddenAll = false;

            if (!permissoes.Cadastrar.Grupos) {
              this.menuData[6].children[1].hidden = true;
            } else
              bHiddenAll = false;

            if (!permissoes.Cadastrar.Produtos) {
              this.menuData[6].children[2].hidden = true;
            } else
              bHiddenAll = false;

            //Reset para hiddenAll
            if (!permissoes.Cadastrar.Funcionarios) {
              this.menuData[6].children[5].children[1].hidden = true;
            } else
              bHiddenAllSubMenu = false;

            if (!permissoes.Cadastrar.Clientes) {
              this.menuData[6].children[5].children[0].hidden = true;
            } else
              bHiddenAllSubMenu = false;

            if (!permissoes.Cadastrar.Promocoes) {
              this.menuData[7].children[0].hidden = true;
            } else
              bHiddenAllSubMenu = false;

            bHiddenAll && bHiddenAllSubMenu && !permissoes.Gerente ? this.menuData[6].hidden = true : null;
            bHiddenAllSubMenu ? this.menuData[6].children[5].hidden = true : null;


            //Verificar consultas //Alterações deve ser consultada na consulta do item
            bHiddenAll = true;
            bHiddenAllSubMenu = true;
            // Verificar consultar ADICIONAR LOG
            if (!permissoes.Consultar.Fornecedores) {
              this.menuData[7].children[0].hidden = true;
            } else
              bHiddenAll = false;

            if (!permissoes.Consultar.Grupos) {
              this.menuData[7].children[1].hidden = true;
            } else
              bHiddenAll = false;

            if (!permissoes.Consultar.Produtos) {
              this.menuData[7].children[2].hidden = true;
            } else
              bHiddenAll = false;

            //Reset para hiddenAll
            if (!permissoes.Consultar.Funcionarios) {
              this.menuData[7].children[4].children[1].hidden = true;
            } else
              bHiddenAllSubMenu = false;

            if (!permissoes.Consultar.Clientes) {
              this.menuData[7].children[4].children[0].hidden = true;
            } else
              bHiddenAllSubMenu = false;

            bHiddenAll && bHiddenAllSubMenu && !permissoes.Gerente ? this.menuData[7].hidden = true : null;
            bHiddenAllSubMenu ? this.menuData[7].children[4].hidden = true : null;

            //Relatório de vendas e comissão
            if (!permissoes.Vender) {
              this.menuData[6].children[5].hidden = true;
            }
          }
        })
      }
    });
  }

  ngOnInit() {
    this.onSinenavToggle();

    // setTimeout(() => {
    //   this.onSinenavToggle();
    // }, 50);
  }

  navegar(e, posicao) {
    if (e) {
      this.router.navigate([e]);
    } else
      if (!this.sideNavState) {
        this.sideNavState = true;
        setTimeout(() => {
          this.linkText = this.sideNavState;
        }, 200);
        this._sidenavService.sideNavState$.next(this.sideNavState);

        setTimeout(() => posicao ? this.step = posicao : null, 300);
      }
  }

  onSinenavToggle() {
    this.sideNavState = !this.sideNavState;

    !this.sideNavState ? this.accordion.closeAll() : null;
    !this.sideNavState ? this.step = null : null;

    setTimeout(() => {
      //this.linkText = this.sideNavState;
    }, 200)
    this._sidenavService.sideNavState$.next(this.sideNavState)
  }

}
